import { route } from "quasar/wrappers";
import { useAuthStore } from "src/stores/auth";
import { useBIStore } from "src/stores/bi";
import { useSystemStore } from "src/stores/system";
import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import routes from "./routes";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function ({}) {
  const debug = false;
  const authStore = useAuthStore();
  const systemStore = useSystemStore();
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === "history"
    ? createWebHistory
    : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(
      process.env.MODE === "ssr" ? void 0 : process.env.VUE_ROUTER_BASE
    ),
  });

  Router.beforeEach((to, from, next) => {
    // gerencia a janela
    let params = new Map(
      window.location.search
        .slice(1)
        .split("&")
        .map((kv) => kv.split("="))
    );
    if (params.has("code") && params.has("scope")) {
      if (window.opener) {
        window.opener.postMessage(
          { code: params.get("code"), scope: params.get("scope") },
          window.location.href
        );
      }
      window.close();
    } else {
      // reseta o status da aplicação
      systemStore.setStatus("ok");
      let allowedToEnter = true;
      to.matched.some((record) => {
        // verifica se o usuário está logado
        let isLoggedIn = authStore.isLoggedIn;

        // permite passar caso seja a página inicial e o usuário não esteja logado
        if (!isLoggedIn && record.name === "landing") {
          allowedToEnter = false;
          systemStore.setModule(record.name);
          if (debug) console.log("Router called next: A");
          next();
          return;
        }

        // se for a página inicial e o usuário está logado, redireciona ele de volta
        if (isLoggedIn && record.name === "landing") {
          if (debug) console.log("Router called next: B");
          next(from);
          return;
        }

        // verifica se a página precisa de autorização
        if ("meta" in record) {
          if ("requiresAuth" in record.meta) {
            if (record.meta.requiresAuth) {
              if (!isLoggedIn) {
                // se o usuário não está logado, redireciona ele de volta para a página inicial
                allowedToEnter = false;
                systemStore.setModule("landing");

                if (debug) console.log("Router called next: C");
                next({
                  path: "/",
                  replace: true,
                  // salva a rota original para o usuário voltar
                  query: { redirect: to.fullPath },
                });
                return;
              }
            }
          }
        }
      });

      // se for um destino que precisa de autorização, verifica se o usuário possui autorização
      if (
        (to.path === "/dashboard" && !authStore.hasAccessDashboard) ||
        (to.path === "/process" && !authStore.hasAccessProcess) ||
        (to.path === "/schedule" && !authStore.hasAccessSchedule) ||
        (to.path === "/settings/maintenance" &&
          (!authStore.isAdministrator || !authStore.hasAccessMaintenanceDash))
      ) {
        allowedToEnter = false;

        if (debug) console.log("Router called next: D");
        next({
          path: "/error",
          replace: true,
          query: { accessDenied: true },
        });
        return;
      }

      if (allowedToEnter) {
        setPageVars(to.path);
        systemStore.setModule(to.name);

        if (debug) console.log("Router called next: E");
        next();
      }
    }
  });

  return Router;
});

function setPageVars(path, store) {
  if (path !== "/bi") {
    const biStore = useBIStore();
    biStore.setBiExport(false);
  }
  if (path == "/updates") {
    const systemStore = useSystemStore();
    systemStore.setMenu({
      title: "Atualização de Sistema",
      modulo: "update",
    });
  }
}
